


























import { Component, Vue, Prop } from "vue-property-decorator";
import fb from "@/firebaseConfig";
import { Members, Member } from "jsk-shared";

@Component({})
export default class AddEditMembers extends Vue {
  @Prop()
  memberId!: string;
  members: any = [];
  search: string = "";
  loading: boolean = true;
  headers: any = [
    {
      text: "Member Name",
      align: "left",
      value: "name"
    }
  ];

  editMember(memberId: string) {
    this.$router.push("/members/edit/" + memberId);
  }

  created() {
    this.loading = true;
    fb.db.doc("/cache/memberCache").onSnapshot(d => {
      let members: any = [];
      if (d.data()) {
        members = d.data();
        this.members = members.members;
      }

      this.loading = false;
    });
  }
}
